export default __webpack_public_path__ + "static/media/ContinueArrow.72335c4f.svg";